<div class="flex items-start justify-center h-full -m-4">
  <div class="w-full max-w-md p-4">
    <div class="bg-white rounded-lg border border-gray-200 p-8 shadow-sm">
      <div class="text-center mb-8">
        <h1 class="text-2xl font-semibold text-gray-900 mb-2">{{ 'login.title' | translate }}</h1>
        <p class="text-sm text-gray-500">{{ 'login.subtitle' | translate }}</p>
      </div>
      <button
        (click)="onLoginClick()"
        class="w-full px-4 py-2 text-sm font-medium rounded-lg border-2 border-main bg-main text-white hover:bg-main-mid transition-colors">
        {{ 'login.button' | translate }}
      </button>
    </div>
  </div>
</div>
